module.exports = __webpack_public_path__ + "img/scoring.a7a9cd21.svg";